'use client';

import { useEffect } from 'react';

/**
 * Inside the website widget's frame, tell the host page how tall we are so
 * the frame never scrolls inside a scroll. Posts to `*` because the host is
 * somebody else's site and we do not know its origin; the message carries
 * nothing but a number and a type, and the widget checks OUR origin before
 * acting on it.
 */
export default function EmbedBridge() {
  useEffect(() => {
    if (window.parent === window) return;
    const post = () => {
      window.parent.postMessage(
        { type: 'mucka:booking:height', height: document.documentElement.scrollHeight },
        '*',
      );
    };
    post();
    const ro = new ResizeObserver(post);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, []);
  return null;
}
